(function () {
    'use strict';

    angular
        .module('app')
        .controller('NavBarController', NavBarController);

    NavBarController.$inject = [
        '$scope',
        '$document',
        '$location',
        '$timeout',
        '$mdSidenav',
        'DialogService',
        'ChilliAuthService',
        'ChilliTenancyService',
        'ChilliUserProfileService',
        'SystemSettingsService',
        'UnsavedChangesService',
        'NavigationAidService',
        'EntityTemplatesService'];

    function NavBarController(
        $scope,
        $document,
        $location,
        $timeout,
        $mdSidenav,
        DialogService,
        ChilliAuthService,
        ChilliTenancyService,
        ChilliUserProfileService,
        SystemSettingsService,
        UnsavedChangesService,
        NavigationAidService,
        EntityTemplatesService) {

        var vm = this;
        vm.toggleMainMenu = toggleMainMenu;
        vm.chilliAuth = ChilliAuthService;
        vm.chilliUserProfile = ChilliUserProfileService;
        vm.notImplemented = notImplemented;
        vm.rootNavClick = rootNavClick;
        vm.getEntityTemplateToolTip = getEntityTemplateToolTip;
        Object.defineProperty(vm, "tenancyOptions", {
            get: function () { return ChilliTenancyService.tenancyOptions; }
        });
        Object.defineProperty(vm, "selectedTenancyId", {
            set: function (value) {
                // Only change tenancy if there are no unsaved changes, or user accepts unsaved changes.
                UnsavedChangesService.promptUnsavedChanges()
                    .then(function () {

                        // If the current object is dirty, skipDirtyCheck needs to be set to true ensure navigation
                        // can continue.
                        // If for some reason a change of tenancy does NOT trigger navigation, the skipDirtyCheck
                        // should be set to false to ensure the app doesn't erroneously consider a dirty object
                        // to be clean.

                        UnsavedChangesService.skipDirtyCheck = true;

                        ChilliTenancyService.selectedTenancyId = value;

                        $timeout(function () {
                            UnsavedChangesService.skipDirtyCheck = false;
                        });
                    });
            },
            get: function () { return ChilliTenancyService.selectedTenancyId; }
        });
        Object.defineProperty(vm, "selectedTenancyName", {
            get: function () {
                if (ChilliTenancyService.selectedTenancyId) {
                    var tenant = _.find(ChilliTenancyService.tenancyOptions, function (o) { return o.id === ChilliTenancyService.selectedTenancyId; });
                    if (tenant) {
                        return tenant.displayName;
                    }
                }
                return '';
            }
        });
        Object.defineProperty(vm, 'editUserLabel', { get: getEditUserLabel });

        activate();

        function activate() {
            resetDropDownMenuIcons();

            // When a md menu is closed, all of the drop down selection icons should be in their unselected state.
            $scope.$on("$mdMenuClose", function () {
                resetDropDownMenuIcons();
            });

            $scope.$watch(function () { return vm.chilliAuth.isAuthenticated; }, function (newVal) {
                if (newVal) {
                    ChilliTenancyService.getTenancyOptions()
                        .then(function () {
                            loadLabels();
                        });

                    loadEntityTemplatesForToolbar();
                }
            });
        }

        function toggleMainMenu() {
            if (!$mdSidenav('mainMenu').isLockedOpen()) {
                $mdSidenav('mainMenu').toggle();
            }
        }

        function notImplemented(featureName) {
            var alertText;
            if (featureName) {
                alertText = 'Feature "' + featureName + '" not implemented';
            } else {
                alertText = 'Feature not implemented';
            }

            DialogService.alert(alertText);
        }

        /*
         * Reset the 'drop down selection' icons so they're at their unselected state.
         */
        function resetDropDownMenuIcons() {
            vm.tenancyMenuIcon = 'chevron down';
        }

        /*
         * Load the mandatory and optional labels which will be used for input fields.
         */
        function loadLabels() {
            var labels = [];

            SystemSettingsService.query()
                .then(function (data) {
                    var mandatorySetting = _.find(data.SystemSettings, function (systemSetting) {
                        return systemSetting.Name === 'Mandatory Label';
                    });

                    var optionalSetting = _.find(data.SystemSettings, function (systemSetting) {
                        return systemSetting.Name === 'Optional Label';
                    });

                    labels.push('--mandatoryLabel: "' + (!_.isNil(mandatorySetting) ? mandatorySetting.Value : ' (Required)') + '";');
                    labels.push('--optionalLabel: "' + (!_.isNil(optionalSetting) ? optionalSetting.Value : ' (Optional)') + '";');
                }, function (response) {
                    labels = ['--mandatoryLabel: " (Required)";', '--optionalLabel: " (Optional)";'];
                })
                .finally(function () {
                    setLabels(labels);
                });
        }

        /*
         * Sets the subscript labels for mandatory and optional fields.
         */
        function setLabels(labels) {
            var chilliDocsStyleSheet = _.find($document[0].styleSheets, function (styleSheet) {
                return styleSheet.title === 'ChilliDocs Main';
            });

            if (!_.isNil(chilliDocsStyleSheet)) {
                var existingMandatoryRuleIndex = null;

                var i = 0;
                angular.forEach(chilliDocsStyleSheet.CSSRuleList, function (cssRule) {
                    if (cssRule.selectorText === ':root') {
                        existingMandatoryRuleIndex = i;
                    }

                    i++;
                });

                if (!_.isNil(existingMandatoryRuleIndex)) {
                    chilliDocsStyleSheet.deleteRule(existingMandatoryRuleIndex);
                }

                chilliDocsStyleSheet.insertRule(':root { ' + _.reduce(labels, function (sum, n) { return sum + n; }) + ' }', 0);
            }
        }

        /**
         * @returns {string} Label for the "edit user" button
         */
        function getEditUserLabel() {
            var label = 'Edit ';

            if (!_.isNil(vm.chilliUserProfile.userProfile) &&
                !_.isNil(vm.chilliUserProfile.userProfile.EntityTemplate) && 
                !_.isNil(vm.chilliUserProfile.userProfile.EntityTemplate.Name)) {

                label += vm.chilliUserProfile.userProfile.EntityTemplate.Name;
            } else {
                label += 'User';
            }

            if (!_.isNil(vm.chilliUserProfile.userProfile) &&
                !_.isNil(vm.chilliUserProfile.userProfile.PreviewNameText) &&
                vm.chilliUserProfile.userProfile.PreviewNameText !== '') {

                label += ' - ' + vm.chilliUserProfile.userProfile.PreviewNameText;
            }

            return label;
        }

        /**
         * Load vm.entityTemplatesForToolbar
         *
         * @return {promise} Resolves once entity templates for toolbar are loaded.
         */
        function loadEntityTemplatesForToolbar() {
            return EntityTemplatesService.query()
                .then(getEntityTemplatesOk);

            function getEntityTemplatesOk(data) {
                _.remove(data.EntityTemplates, { Active: false });
                _.remove(data.EntityTemplates, { UserGranted: false });
                _.remove(data.EntityTemplates, { ShowOnToolbar: false });
                vm.entityTemplatesForToolbar = _.sortBy(data.EntityTemplates, function (entityTemplate) { return entityTemplate.PluralName; });

                _.forEach(vm.entityTemplatesForToolbar, function (entityTemplate) {
                    entityTemplate.navLink = '#/entities' + '?entityTemplateId=' + entityTemplate.Id;
                });
            }
        }

        /**
         * Genearte a tool tip for the supplied entity template
         *
         * @return {string} Tool tip for the supplied entity template
         */
        function getEntityTemplateToolTip(entityTemplate) {
            var toolTip =  'View ' + entityTemplate.PluralName;
            
            if (!_.isNil(entityTemplate.Description) && entityTemplate.Description !== '') {
                toolTip += '<br/>' + entityTemplate.Description;
            }
            
            return toolTip;
        }

        /**
         * Clicking on root navigation links may require clearing navigation history,
         * but only if clicking that link will cause navigation. I.e. change page.
         */
        function rootNavClick(link) {
            var existingUrl = '#' + $location.url().toLowerCase();
            var sanitisedLink = link.toLowerCase();

            if (existingUrl != sanitisedLink) {
                NavigationAidService.pathHistory.length = 0;
            }
        }
    }
})();